import { type ViewField, ViewFieldSupport } from '@air/api/types';

export const isViewFieldSortField = (viewField: ViewField) => viewField.supports.includes(ViewFieldSupport.sort);
export const isViewFieldVisibilityField = (viewField: ViewField) =>
  viewField.supports.includes(ViewFieldSupport.visibility);
